var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66634V5.33301C4 3.12634 4.66667 1.33301 8 1.33301C11.3333 1.33301 12 3.12634 12 5.33301V6.66634",
    stroke: "#2e68ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 12.3333C8.91917 12.3333 9.66536 11.5871 9.66536 10.6667C9.66536 9.74619 8.91917 9 7.9987 9C7.07822 9 6.33203 9.74619 6.33203 10.6667C6.33203 11.5871 7.07822 12.3333 7.9987 12.3333Z",
    stroke: "#2e68ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 14.667H4.66536C1.9987 14.667 1.33203 14.0003 1.33203 11.3337V10.0003C1.33203 7.33366 1.9987 6.66699 4.66536 6.66699H11.332C13.9987 6.66699 14.6654 7.33366 14.6654 10.0003V11.3337C14.6654 14.0003 13.9987 14.667 11.332 14.667Z",
    stroke: "#2e68ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.13fddfd5f54e3676981644134a40c605.svg";
export { ForwardRef as ReactComponent };